import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-light-svg-icons';
import { Box } from '@mui/material';
import { useNotifier } from '../notifier';

export function CopyToClipboard(props: { toCopy: string; title: string; toastText?: string }) {
  const { toCopy, title, toastText } = props;

  const { dispatch } = useNotifier();

  function handleCopy() {
    navigator.clipboard.writeText(toCopy);
    if (toastText) {
      dispatch({ type: 'notify', payload: { message: toastText } });
    }
  }

  return (
    <Box sx={{ padding: '5px', cursor: 'pointer' }} onClick={handleCopy}>
      <FontAwesomeIcon icon={faCopy} /> {title}
    </Box>
  );
}
